export const LoginButtonStyles = {
    backgroundColor: "#e0e0e0",
    color: "black",
    '&:hover': {
        backgroundColor: "#d5d5d5",
    },
}